const modalCompartirAviso = {
  Compartir: 'Compartir',
  'Comparte este aviso': 'Comparte este aviso',
  'Copiar el enlace': 'Copiar el enlace',
}

export default modalCompartirAviso
